export enum PermissionAbilityName {
    Static = 'StaticPermissionAbility',
    Risk = 'RiskPermissionAbility',
    Controls = 'ControlPermissionAbility',
    Actions = 'ActionPermissionAbility',
    ActionsRo = 'ActionRoPermissionAbility',
    Risk_Add = 'AddRisk',
    Risk_Edit = 'EditRisk',
    Risk_Register_View = 'ViewRiskRegister',
    Services = 'ServicePermissionAbility',
    RevampedIncidentRegister = 'RevampedIncidentRegisterPermissionAbility',
    UserManagement = 'UserManagementPermissionAbility',
}
